export const msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_AZURE_CLIENT_ID as string,
        authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AZURE_TENANT_ID}`,
        redirectUri: process.env.VUE_APP_AZURE_REDIRECT_URI as string,
        postLogoutRedirectUri: process.env.VUE_APP_AZURE_POST_LOGOUT_REDIRECT_URI as string,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "email", "User.Read"],
};

export const apiTokenRequest = {
    scopes: [process.env.VUE_APP_API_SCOPE],
};